import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  AuthService, RequestVerificationService, RequestVerificationCodeType,
} from '@nimmsta/ng-commons-lib';

@Component({
  selector: 'app-request-access',
  templateUrl: './request-access.component.html',
  styleUrls: ['./request-access.component.scss'],
})
export class RequestAccessComponent {
  public emailVerificationForm = this.fb.group(
    {
      email: ['', [Validators.required, Validators.email]],
      acceptTerms: [false, [Validators.requiredTrue]],
    },
  );

  public requestAccessForm = this.fb.group(
    {
      organization: ['', [Validators.required, Validators.minLength(3)]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      verificationCode: ['', [Validators.required]],
      acceptTerms: [false, [Validators.requiredTrue]],
    },
  );

  public isLoading = false;

  public error?: HttpErrorResponse;

  public emailVerificationSubmitted = false;

  public isSubmitted = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private requestVerificationService: RequestVerificationService,
  ) {
    // fetch query params to skip the email verification step
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const email = urlParams.get('email');
    if (code && email) {
      this.requestAccessForm.controls.verificationCode.setValue(code);
      this.requestAccessForm.controls.verificationCode.disable();
      this.requestAccessForm.controls.email.setValue(email);
      this.emailVerificationSubmitted = true;
    }
  }

  onEmailVerificationSubmit() {
    this.isLoading = true;
    this.error = undefined;
    const email = this.emailVerificationForm.controls.email.value!;
    this.requestVerificationService
      .initiateAnonymousRequestVerification(
        email,
        RequestVerificationCodeType.ACCESS_REQUEST_EMAIL_VERIFICATION,
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.emailVerificationSubmitted = true;
          this.requestAccessForm.controls.email.setValue(email);
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.error = error;
        },
      });
  }

  onSubmit() {
    this.isLoading = true;
    this.error = undefined;
    const verificationCode = this.requestAccessForm.controls.verificationCode.value!;
    const organization = this.requestAccessForm.controls.organization.value!;
    const firstName = this.requestAccessForm.controls.firstName.value!;
    const lastName = this.requestAccessForm.controls.lastName.value!;
    const email = this.requestAccessForm.controls.email.value!;
    this.authService.requestAccess(verificationCode, email, firstName, lastName, organization).subscribe({
      next: () => {
        this.isLoading = false;
        this.isSubmitted = true;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.error = error;
      },
    });
  }
}
